import Dashboard from './pages/Dashboard/Dashboard.js';
import Email from './pages/Email/Email.js';

import {
  BrowserRouter,
   
  Route,

} from "react-router-dom";
function App() {
  return (
    <>
    <BrowserRouter>

          
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/email" component={Email} />
          
     </BrowserRouter> 
    
    </>
  );
}

export default App;
